// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.implementation-guide-page {
  width: 100%;
  height: 100vh;
  min-height: 100vh;
  overflow: hidden;
}

.implementation-guide-page__frame {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/ImplementationGuidePage/ImplementationGuidePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;AACX","sourcesContent":[".implementation-guide-page {\n  width: 100%;\n  height: 100vh;\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.implementation-guide-page__frame {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
